import React, { useState, useEffect } from 'react';
import { Calculator, ArrowRight, AlertTriangle } from 'lucide-react';
import { getTerminalSpotsLeft } from '../lib/urgency';

const StickyCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const ctaLink = "https://calendly.com/davwaysolution/review";
  const spotsLeft = getTerminalSpotsLeft();

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-16 right-6 z-50 flex flex-col items-end gap-2 animate-slow-bounce">
      {/* Urgency pill */}
      <div className="flex items-center gap-1.5 rounded-full px-3 py-1.5 shadow-lg text-xs font-bold" style={{ backgroundColor: '#FF4D2D', color: 'white' }}>
        <AlertTriangle size={12} />
        <span>{spotsLeft} spots left</span>
      </div>
      {/* CTA button */}
      <a
        href="/calculator"
        className="flex items-center gap-3 text-white font-bold px-6 py-4 rounded-full shadow-2xl hover:shadow-green-500/30 transition-all duration-300 group"
        style={{ backgroundColor: '#22C55E' }}
        data-testid="sticky-cta-btn"
      >
        <Calculator size={20} className="group-hover:scale-110 transition-transform" />
        <span className="hidden sm:inline">Calculate My Savings</span>
        <span className="sm:hidden">Calculate</span>
        <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
      </a>
    </div>
  );
};

export default StickyCTA;
